import { render } from "./Course.vue?vue&type=template&id=53edb896"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=53edb896&lang=css"
script.render = render

export default script